import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=df8426fe&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=df8426fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8426fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df8426fe')) {
      api.createRecord('df8426fe', component.options)
    } else {
      api.reload('df8426fe', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=df8426fe&scoped=true&", function () {
      api.rerender('df8426fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V0jqQNr6L1JH/JS/comp/DocBox.vue"
export default component.exports